export default __webpack_public_path__ + "static/media/4p0OpY0A.dc36d837.jpg";